import { postRequest } from '@/core';
import { trips } from '@/requests';

export default async function getTripsByIdsRequest(ids) {
	let url = trips.getByIds();
	let response = await postRequest(url, {}, { tripIds: ids });
	return response;
}
